import { render, staticRenderFns } from "./LockToggle.vue?vue&type=template&id=09cdf302&scoped=true"
import script from "./LockToggle.vue?vue&type=script&lang=js"
export * from "./LockToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cdf302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09cdf302')) {
      api.createRecord('09cdf302', component.options)
    } else {
      api.reload('09cdf302', component.options)
    }
    module.hot.accept("./LockToggle.vue?vue&type=template&id=09cdf302&scoped=true", function () {
      api.rerender('09cdf302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/LockToggle.vue"
export default component.exports